export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-crop-b1e7c1a217dfc8f4c2a420751c7a30e2.svg";